import React, {Component} from 'react'
import CBaseComponent from '@/components/CBaseComponent'
import {savaScore} from "@/servers/storeManageApi";
import './index.scss'
import {Button, Modal, Input, message,Checkbox} from "antd";
import CCheckbox from '@/components/CForm/CCheckbox'
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {getInfo} from "../../../../servers/menuAPI";
import store from "../../../../redux";
import { getStorage} from "@/utils";
import {refreshMenu} from "../../../../redux/common/action";
import CInput from '@/components/CForm/CInput'
import CTable from '@/components/CTable'
import { tableData } from './data'
@CBaseComponent
class SystemScore extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangetj = this.onChangetj.bind(this);
    this.onChangetext = this.onChangetext.bind(this)
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    notes:''
  }

  onSubmit(){
    const params = []
    this.state.dataSource.forEach(item=>{
      params.push({
        id:item.id,
        score:item.checked,
      })
    })
    params[0].notes = this.state.notes
    savaScore(params).then(res=>{
      if(res.statecode === 0) {
        this.props.refreshMenu(true)
        message.success('保存成功');
        // this.props.history.push({
        //   pathname: '/informationDeclaration/addition/proposalScore',
        // });
      } else {
        message.error(res.statemessage);
      }
    })
  }

  changeinput(e,index){
    e.persist()
    const d = this.state.data
    d.forEach((item,i)=>{
      if (index === i) {
        item.score = e.target.value
      }
    })
    this.setState({
      data:d
    })
  }

  onChangetj(value,data){
    console.log(value);
    const d = this.state.dataSource
    d.forEach(item=>{
      if (item.id === data.id) {
        if (value.length === 0) {
          item.checked = '0'
        } else
        {
          item.checked = value[0]
        }
      }
    })
    this.setState({
      dataSource:d
    })
  }

  onChangetext(data){
    this.setState({
      notes:data
    })
  }

  onSelect(){
    const params = {
      annual:getStorage('year'),
      indid:'4.2',
      museumid:store.getState().libraryid,
    }
    getInfo(params).then(res=>{
      res.records.forEach(item=>{
        if (Number(item.score) === 1){
          item.checked = '1'
        } else {
          item.checked = '0'
        }
      })
      this.setState({
        dataSource:res.records,
        notes: decodeURIComponent(res.extra.scoretips)
      })
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
        <div className='detail-container' id="top">
          <div className="import">
          <h3 style={{color:'red'}}>警示减分建议</h3>
          <CTable ref='historyRecordDeleteUserList' checked={false} loading={false} columns={this.state.columns} dataSource={this.state.dataSource}>
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='jf'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CCheckbox value={record.checked} onChange={(e)=>{this.onChangetj(e,record)}} options={[{value:'1',id:'1',name:' 建议减分',lable:' 建议减分'}]}> 建议减分</CCheckbox>
                    </div>
                )} />
          </CTable>
          </div>
          <div className="import">
            <h3 style={{color:'red'}}>建议警示减分理由</h3>
            <CInput type='textarea'
                    value={this.state.notes}
                    newExpand={{autoSize:{minRows: 8, maxRows: 10}}}
                    onChange={this.onChangetext}
            />
          </div>
          <div className='detail-submit' style={this.props.collapsed?{width:'calc(100vw - 260px)',left:'260px'}:{width:'calc(100vw - 5px)',left:'50px'}}>
          <Button type="primary" className='yl' onClick={this.onSubmit}>保存</Button>
          </div>
        </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.collapsed,  // 侧边栏是否展开
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps,mapDispatchToProps))(SystemScore);
